export default {

    title: "Načítání...",

    responses: {
        "404": {
            title: "Došlo k chybě",
            header: "Došlo k chybě",
            message: "Platný token nenalezen. Platnost vašeho tokenu možná vypršela."
        },
        "200_tfalogin": {
            title: "Ověření přihlášení",
            header: "@:views.tunnel.service.response.200_tfalogin.title",
            message: "Přihlášení bylo ověřeno."
        },
        "404_tfalogin": {
            title: "Ověření přihlášení",
            header: "@:views.tunnel.service.response.404_tfalogin.title",
            message: "Platný token nenalezen. Platnost vašeho tokenu možná vypršela."
        },
        "200_tfaaddress": {
            title: "Ověření adresy",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Děkujeme za ověření vaší adresy. Nyní si ji můžete zvolit jako dodací adresu při zadávání objednávky."
        },
        "404_tfaaddress": {
            title: "Ověření adresy",
            header: "@:views.tunnel.service.response.404_tfaaddress.title",
            message: "Platný token nenalezen. Platnost vašeho tokenu možná vypršela."
        },
        "201_delivery": {
            title: "Děkuju",
            header: "Děkuju",
            message: "Děkuji za vaši odpověď."
        },
        "201_shipment_received": {
            title: "Děkuju",
            header: "Děkuju",
            message: "Děkuji za vaši odpověď."
        },
        "400": {
            title: "Špatný požadavek. Došlo k chybě.",
            header: "@:views.tunnel.service.response.400.title",
            message: "Špatný požadavek. Došlo k chybě."
        }
    }
}